
//PERFILES Y USUARIOS
export const PROFILES = {
    ADMIN: 1,
    MASTER: 2
}
